export default __webpack_public_path__ + "static/media/i_bus-jeonse_gn.55fdca2b.svg";